import React, { useEffect } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  getTransactionList,
} from '../../redux/actions/transaction';
import TheLayout from '../../layout/TheLayout';
import TransactionItem from './transactionItem';

const keywords = ['TERRA', 'transaction', '注文履歴'];

const Transaction = () => {
  const transactionList = useSelector((state) => state.transaction.transactionList, shallowEqual);
  const accessToken = useSelector((state) => state.auth.accessToken, shallowEqual);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn, shallowEqual);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getTransactionList(accessToken, -1, 0));
    }
  }, [accessToken, dispatch, isLoggedIn]);

  if (!isLoggedIn) {
    return <Redirect to="/login" />;
  }

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>注文履歴｜株式会社TERRA</title>
      </Helmet>
      <div className="transaction">
        <div className="container pb-5 pt-5">
          {
          transactionList?.map((t) => (
            <>
              <TransactionItem key={t.id} transaction={t} />
              <br />
            </>
          ))
          }
        </div>
      </div>
    </TheLayout>
  );
};
export default Transaction;
